export interface CreateAttachmentError {
    errorMessage: string;
    errorCode: string;
}

export const NonExistentMailboxErrorCode = 'ErrorNonExistentMailbox';
